import React from 'react'
import { Card, CardContent } from '@/components/ui/card'
import { AvatarMediaPreview } from 'AdminPanel/SpineAvatars/SpineAvatars/components/AvatarMediaPreview'
import { cdnUrl } from 'commons/cdn'
import { MyImage } from 'components/MyImage'
import {
  getAvatarListItemKind,
  type AvatarListItem,
} from '../utils/avatarList'

const THUMB_CLASS = 'h-[150px] w-[150px] shrink-0'

const LIST_TYPE_LABEL: Record<string, string> = {
  avatar: 'Avatar',
  oc: 'OC',
  spineAvatar: 'Spine Avatar',
}

type ThumbProps = {
  imageUrl?: string
  videoUrl?: string
  alt: string
}

function Thumb({ imageUrl, videoUrl, alt }: ThumbProps) {
  const resolvedImage = imageUrl?.trim() ? cdnUrl(imageUrl) : undefined
  const resolvedVideo = videoUrl?.trim() ? videoUrl : undefined

  return (
    <div className={`${THUMB_CLASS} overflow-hidden rounded-md border bg-black`}>
      {resolvedVideo ? (
        <AvatarMediaPreview
          videoUrl={resolvedVideo}
          imageUrl={imageUrl}
          lazyVideo
          className="h-full w-full"
        />
      ) : resolvedImage ? (
        <MyImage
          src={resolvedImage}
          alt={alt}
          preview
          lazy
          className="h-full w-full object-contain"
        />
      ) : (
        <div className="flex h-full w-full items-center justify-center text-[10px] text-muted-foreground">
          -
        </div>
      )}
    </div>
  )
}

type Props = {
  item: AvatarListItem
}

export default function AvatarListCard({ item }: Props) {
  const kind = getAvatarListItemKind(item)
  const imageUrl = kind === 'oc' ? item.avatar : item.url
  const title = item.name || item.authorName || item.id

  return (
    <Card className="overflow-hidden">
      <CardContent className="flex items-start gap-3 p-3">
        <Thumb
          alt={title}
          imageUrl={imageUrl}
          videoUrl={item.videoPreviewUrl || item.videoUrl}
        />

        <div className="min-w-0 flex-1 space-y-1">
          <p className="line-clamp-2 font-medium leading-snug">{title}</p>
          <p className="truncate text-xs text-muted-foreground">{item.id}</p>
          <p className="text-xs text-muted-foreground">
            {LIST_TYPE_LABEL[kind] ?? kind}
          </p>
          <p className="text-sm text-muted-foreground">
            total reCreate：
            <span className="font-medium text-foreground">
              {item.reCreateCount ?? '-'}
            </span>
          </p>
          <p className="text-sm text-muted-foreground">
            daily reCreate：
            <span className="font-medium text-foreground">
              {item.dailyReCreateCount ?? '-'}
            </span>
          </p>
        </div>
      </CardContent>
    </Card>
  )
}
